var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useMemo } from 'react';
import { Typography } from '@lucidlink/uicore';
import { useSerializedStats } from '../../../query-hooks';
import { MetricsTable } from './components';
export const MetaStoreMetrics = ({ stats }) => {
    _react_refresh_temp_2();
    const { query: { data: serializedStats }, } = useSerializedStats('meta_store', stats);
    const metrics = useMemo(() => {
        if (!serializedStats) {
            return undefined;
        }
        return [
            {
                name: 'FetchData Calls',
                value: serializedStats?.fetchData.success.count,
            },
            {
                name: 'ApplyData Calls',
                value: serializedStats?.applyData.success.count,
            },
            {
                name: 'InvokeProcedure Calls',
                value: serializedStats?.invokeProcedure.success.count,
            },
        ];
    }, [serializedStats]);
    return metrics ? (_jsx(MetricsTable, { data: metrics })) : (_jsx(Typography, { color: "negative", kind: "h5", children: "Cannot load Meta Store metrics" }));
};
_react_refresh_temp_1 = MetaStoreMetrics;
$RefreshReg$(_react_refresh_temp_1, "MetaStoreMetrics");
_react_refresh_temp_2(MetaStoreMetrics, "k0uoxYknZnRVwSi4YJ838faW2Ms=", false, () => [useSerializedStats]);
